import { ProgressGPTReplyModel } from 'api/models';
import { getProgressGPTReplies } from 'api/services';
import useDataQuery from 'modules/shared/hooks/useDataQuery';
import { useCallback } from 'react';

interface IProgressGPTChatProps {
    chatId: string;
}

const useProgressGPTChatData = (props: IProgressGPTChatProps) => {
    const { chatId } = props;

    const progressGPTRepliesQuery = useDataQuery(['progressGPTChatReplies', chatId], () =>
        getProgressGPTReplies(chatId)
    );

    const addReply = useCallback(
        (reply: ProgressGPTReplyModel) => {
            progressGPTRepliesQuery.setData((prevList = []) => {
                const clonedList = prevList.map((row) => ProgressGPTReplyModel.cloneFrom(row.toObject()));

                const alreadyExists = clonedList.find((row) => row._id === reply._id);

                if (!alreadyExists) {
                    clonedList.push(ProgressGPTReplyModel.cloneFrom(reply.toObject()));
                }

                return clonedList;
            });
        },
        [progressGPTRepliesQuery]
    );

    const deleteReply = useCallback(
        (replyId: string) => {
            progressGPTRepliesQuery.setData((prevList = []) => {
                const index = prevList.findIndex((row) => row._id === replyId);

                const clonedList = prevList.map((row) => ProgressGPTReplyModel.cloneFrom(row.toObject()));

                clonedList.splice(index, 1);

                return clonedList;
            });
        },
        [progressGPTRepliesQuery]
    );

    // const addReply = useCallback(
    //     (chat: IProgressGPTReplyModel) => {
    //         return progressGPTRepliesQuery.setData((prevList = []) => {
    //             return produce(prevList, (draftState) => {
    //                 const alreadyExists = draftState.find((row) => row._id === chat._id);
    //                 if (!alreadyExists) {
    //                     draftState.push(chat);
    //                 }
    //             });
    //         });
    //     },
    //     [progressGPTRepliesQuery]
    // );

    // const deleteReply = useCallback(
    //     (replyId: string) => {
    //         return progressGPTRepliesQuery.setData((prevData) => {
    //             return produce(prevData, (draftState) => {
    //                 const index = draftState.findIndex((row) => row._id === replyId);

    //                 if (index !== -1) {
    //                     draftState.splice(index, 1);
    //                 }

    //                 return draftState;
    //             });
    //         });
    //     },
    //     [progressGPTRepliesQuery]
    // );

    const deleteAllReplies = useCallback(() => {
        progressGPTRepliesQuery.setData([]);
    }, [progressGPTRepliesQuery]);

    return {
        isLoading: progressGPTRepliesQuery.isLoading,
        replies: progressGPTRepliesQuery.data,
        addReply,
        deleteReply,
        deleteAllReplies,
    };
};

export default useProgressGPTChatData;
